import {
  BasicInfoSupplier,
  ActivityAreaForm,
  BankForm,
  DocumentsEquipmentSupplier,
  UpdateDocumentsEquipmentSupplier,
  DocumentsSupplier,
  TermsSupplier,
  ObjectionSupplier,
} from './components';
import { AuditorForm } from '../mainFormAuditor/components';
import { ocForm } from '../mainFormOC/components';
import { tabs } from './components/basicInfoSupplier/tabs';
import { isEmpty, isNil } from 'lodash';

export const stepsForeignSupplier = ({ activeTaskName, auditorComment, objCommentBen, objectionCommitteeComment }) =>  {
  return [
  {
    name: 'BASICFORMSUPPLIER',
    label: 'Βασικά Στοιχεία Προμηθευτή',
    Component: BasicInfoSupplier,
    tabsComponent : tabs(),
    subtabs: true,
    id: 0,
  },
  {
    name: 'AREAFORM',
    label: 'Περιοχή Δραστηριότητας',
    Component: ActivityAreaForm,
    id: 1,
  },
  {
    name: 'EQUIPMENTDOCUMENT',
    label: 'Εξοπλισμός',
    Component: DocumentsEquipmentSupplier,
    id: 2,
  },
  {
    name: 'DOCUMENTS',
    label: 'Έγγραφα',
    Component: DocumentsSupplier,
    id: 3,
  },
  {
    name: 'TERMS',
    label: 'Όροι και Προϋποθέσεις',
    Component: TermsSupplier,
    id: 4,
  },
  {
    name: 'EVALUATIONFORM',
    label: 'Αξιολόγηση Αίτησης',
    Component: AuditorForm,
    hidden: (isNil(auditorComment) || (auditorComment && (activeTaskName === "task.name.application_evaluation_by_auditor" || activeTaskName === "task.name.application_returned_to_supplier"))),
    id: 6,
  },
  {
    name: 'OBJECTIONFORM',
    label: 'Ένσταση',
    Component: ObjectionSupplier,
    id: 7,
    hidden: !((!isNil(auditorComment) && activeTaskName === "task.name.temporary_rejected") || !isNil(objCommentBen)),
  },
  {
    name: 'OBJECTIONEVALUATIONFORM',
    label: 'Αξιολόγηση Ένστασης',
    Component: ocForm,
    id: 8,
    hidden: !(!isNil(objectionCommitteeComment) && (activeTaskName === "task.name.accepted" || activeTaskName === "task.name.final_rejected")),
  },
  {
    name: 'UPDATEEQUIPMENTDOCUMENT',
    label: 'Αννανέωση Εξοπλισμού',
    Component: UpdateDocumentsEquipmentSupplier,
    id: 8,
    hidden: !((activeTaskName === "task.name.accepted")),
  },

].filter(item => !item?.hidden)
};